import { render } from "./MergeTokenPicker.vue?vue&type=template&id=e1481020&scoped=true"
import script from "./MergeTokenPicker.vue?vue&type=script&lang=js"
export * from "./MergeTokenPicker.vue?vue&type=script&lang=js"

import "./MergeTokenPicker.vue?vue&type=style&index=0&id=e1481020&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1481020"]])

export default __exports__